import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = { id: number };
type Response = Reservation;

export const useReservation = createQuery<Response, Variables, AxiosError>({
  queryKey: ['reservations/renter/id'],
  fetcher: ({ id }) => {
    return client.get(`v2/reservations/${id}`).then((response) => {
      return response.data.data;
    });
  },
});
